import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
	aguardando: false,
    lista: [], 
    filtro: {
        data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getTimestampParaData(new Date().getTime() - 2592000000)),
        data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
        ids_unidades: null,
        ids_motoristas: null,
        ids_distribuidoras: null,
        ids_veiculos: null
    },
    listaUnidade: [],
    listaProduto: [],
    listaTanque: [],
    listaMotorista: [],
    listaVeiculo: [],
    listaDistribuidora: [],
    listaPedido: [],
    listaTipo: [
        { id: 1, valor: 'Compra' },
        { id: 2, valor: 'Retorno do Cliente' },
        { id: 3, valor: 'Quebra de Estoque' }
    ],
    listaEntradaBase: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'ENTRADA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        
        case 'ENTRADA_SET_AGUARDANDO':
            return { ...state,
                aguardando: action.payload
            };
		
		case 'ENTRADA_SET_FILTRO':
			return { ...state,
				filtro: action.payload
			};

        case 'ENTRADA_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'ENTRADA_BASE_LISTADO':
            return { ...state, listaEntradaBase: action.payload.data };

        case 'ENTRADA_PEDIDO_SELECT_LISTADO':
            return { ...state, listaPedido: action.payload.data };

        case 'ENTRADA_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
            };

        case 'ENTRADA_PRODUTO_SELECT_LISTADO':
			return {
				...state,
				listaProduto: action.payload.data
            };

        case 'ENTRADA_TANQUE_SELECT_LISTADO':
			return {
				...state,
				listaTanque: action.payload.data
            };

        case 'ENTRADA_MOTORISTA_SELECT_LISTADO':
			return {
				...state,
				listaMotorista: action.payload.data
            };

        case 'ENTRADA_VEICULO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculo: action.payload.data
            };

        case 'ENTRADA_DISTRIBUIDORA_SELECT_LISTADO':
			return {
				...state,
				listaDistribuidora: action.payload.data
            };
                      
        default:
            return state;
    }
}
